import React from 'react'
import Sketch from "react-p5";
import { draw, setup, windowResized } from '../../p5/sketch'
import './_p5-background.scss';


function P5Background() {
  return (
    <div className='p5-background'>
        <Sketch setup={setup} draw={draw} windowResized={windowResized} />
    </div>
  )
}

export default P5Background